import { SxProps, Theme } from "@mui/material";

export const styles: Record<string, SxProps<Theme>> = {
  startAdornmentBox: {
    display: "flex",
    flexDirection: "row",
    gap: "6px",
    alignItems: "center",
  },
  equalSign: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "22px",
    letterSpacing: "0%",
    color: "#2A2D31",
  },
  satsText: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0%",
  },
  usdText: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontStyle: "Medium",
    fontSize: "12px",
    lineHeight: "20px",
    letterSpacing: "0%",
    textAlign: "center",
    verticalAlign: "middle",
    color: "#8BC5F4",
    whiteSpace: "nowrap",
  },
};
